import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "flex justify-between items-end" }
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-capGrey" }, "*Payments initiated prior to 2021 may be combined or have incomplete data", -1)
const _hoisted_5 = { class: "flex flex-col lg:flex-row gap-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Initiate Payment ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Update Payment Method ")
const _hoisted_8 = {
  key: 0,
  class: "mt-6 text-center text-capDarkPurple"
}
const _hoisted_9 = {
  key: 1,
  class: "space-y-3 mt-3"
}
const _hoisted_10 = { class: "flex items-center justify-between gap-4 pb-2 mb-2 border-b border-capGrey border-opacity-30 text-base" }
const _hoisted_11 = { class: "flex items-center gap-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 mr-1" }, "Transaction Date", -1)
const _hoisted_13 = { class: "grid md:grid-cols-2 gap-3" }
const _hoisted_14 = { class: "space-y-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Subtotal", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Tax", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Total", -1)
const _hoisted_18 = { class: "space-y-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-gray-500" }, "Payment Method", -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
}
const _hoisted_22 = { class: "bg-white rounded-lg shadow-xl w-full max-w-sm mx-4 overflow-hidden" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 pt-5 pb-4 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-capDarkPurple font-semibold text-base" }, "Initiate Payment")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-capGrey text-sm" }, "This will initiate the payment process to bring your account current using the default payment method on file.")
], -1)
const _hoisted_25 = { class: "flex justify-end gap-3 px-6 pb-5" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = ["disabled"]

import { ref, computed } from 'vue';
    import { useStore } from 'vuex';
    import { useToast } from 'vue-toastification';
    import PaymentMethodsDrawer from './PaymentMethodsDrawer.vue';
    import SharedAPI from '@/api/SharedAPI';
    import { getFmError } from '@/api/fmError';
    import { useCurrency } from '@/composables/useCurrency';
    import { splitAddressLabel } from '@/composables/useAddressLabel';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ContractPayments',
  setup(__props) {

    const toast = useToast()
    const paymentMethodDialog = ref(false)
    const isInitiatingPayment = ref(false)
    const showInitiatePaymentDialog = ref(false)

    const store = useStore()
    const user = computed(() => store.state.user)
    const contract = computed(() => store.state.contract)
    const addressLabel = computed(() => splitAddressLabel(contract.value.zctWebPhysicalAddressLabel))
    const excludedPaymentStatuses = ['Voided - Error', 'Default Error']
    const paymentList = computed(() => store.state.paymentList.filter((payment: any) => !excludedPaymentStatuses.includes(payment.status)))

    const hasPaymentMethodOnFile = computed(() => {
        const raw = contract.value.zctPaymentMethodArray
        if (!raw) return false
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
        return Object.keys(parsed).length > 0
    })

    function cancelInitiatePaymentDialog() {
        showInitiatePaymentDialog.value = false
    }

    async function confirmInitiatePayment() {
        if (isInitiatingPayment.value) return
        isInitiatingPayment.value = true
        try {
            const res = await SharedAPI.runScript('Web - Initiate Payment', contract.value.__kptID)
            const error = getFmError(res)
            if (error) {
                toast.error(error)
                return
            }
            toast.success('Your payment request has been submitted to accounting and will be reflected within the next business day.')
            showInitiatePaymentDialog.value = false
        } catch (e) {
            console.error('[ContractPayments] confirmInitiatePayment:', e)
            toast.error('Failed to initiate payment. Please try again.')
        } finally {
            isInitiatingPayment.value = false
        }
    }

    function getPaymentMethodParts(details?: string) {
        if (!details) return []
        return details.split(' - ').map(part => part.trim())
    }


    const defaultCurrency = computed(() =>
        user.value?.currencyCode ??
        (user.value?.country === 'CA' ? 'CAD' : 'USD')
    )

    const defaultLocale = computed(() =>
        user.value?.locale ?? (defaultCurrency.value === 'CAD' ? 'en-CA' : 'en-US')
    )

    const { formatMoney } = useCurrency({
        defaultCurrency: defaultCurrency.value,
        locale: defaultLocale.value
    })

return (_ctx: any,_cache: any) => {
  const _component_c_container_heading = _resolveComponent("c-container-heading")!
  const _component_c_badge = _resolveComponent("c-badge")!
  const _component_c_container_text = _resolveComponent("c-container-text")!
  const _component_c_button = _resolveComponent("c-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PaymentMethodsDrawer, {
      modelValue: paymentMethodDialog.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paymentMethodDialog).value = $event)),
      "contract-id": _unref(contract).__kptID
    }, null, 8, ["modelValue", "contract-id"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_c_container_heading, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(contract).contractNumberDisplay), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_c_badge, {
              status: _unref(contract).status
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(contract).status), 1)
              ]),
              _: 1
            }, 8, ["status"])
          ]),
          _createVNode(_component_c_container_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(addressLabel).street), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_c_container_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(addressLabel).cityStateZip), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_c_container_text, {
            class: "mt-3",
            secondary: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString('Active on ' + _unref(contract).activeDate), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            ((_unref(contract).status === 'Past Due' || _unref(contract).paymentMethod === 'Billed') && _unref(hasPaymentMethodOnFile))
              ? (_openBlock(), _createBlock(_component_c_button, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showInitiatePaymentDialog.value = true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_c_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (paymentMethodDialog.value = true))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ])
      ]),
      (!_unref(paymentList).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " No payments have been received. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paymentList), (payment, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: payment.__kptID + ' + ' + index,
                class: "border-2 border-capGrey border-opacity-50 rounded-md p-3"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, [
                      _hoisted_12,
                      _createElementVNode("span", null, _toDisplayString(payment.datePaid || '—'), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_c_badge, {
                      status: payment.status
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(payment.status), 1)
                      ]),
                      _: 2
                    }, 1032, ["status"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _hoisted_15,
                      _createElementVNode("div", null, _toDisplayString(_unref(formatMoney)(payment.amountDue)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_16,
                      _createElementVNode("div", null, _toDisplayString(_unref(formatMoney)(payment.zcnTotalTax ?? 0)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_17,
                      _createElementVNode("div", null, _toDisplayString(_unref(formatMoney)(payment.zcnPaymentTotal)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", null, [
                      _hoisted_19,
                      (getPaymentMethodParts(payment.zctCreditCardDetails).length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getPaymentMethodParts(payment.zctCreditCardDetails), (part, partIndex) => {
                            return (_openBlock(), _createElementBlock("div", { key: partIndex }, _toDisplayString(part), 1))
                          }), 128))
                        : (_openBlock(), _createElementBlock("div", _hoisted_20, "—"))
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (showInitiatePaymentDialog.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    disabled: isInitiatingPayment.value,
                    onClick: cancelInitiatePaymentDialog,
                    class: "px-4 py-2 text-sm text-capGrey hover:text-capDarkPurple transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                  }, " Cancel ", 8, _hoisted_26),
                  _createElementVNode("button", {
                    disabled: isInitiatingPayment.value,
                    onClick: confirmInitiatePayment,
                    class: "px-4 py-2 text-sm bg-capPurple text-white rounded-md hover:bg-capDarkPurple transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
                  }, _toDisplayString(isInitiatingPayment.value ? 'Initiating…' : 'Confirm'), 9, _hoisted_27)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    ])
  ], 64))
}
}

})